import { render, staticRenderFns } from "./AppointmentMessagePreviewDialog.vue?vue&type=template&id=62b73bbd&scoped=true"
import script from "./AppointmentMessagePreviewDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentMessagePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./AppointmentMessagePreviewDialog.vue?vue&type=style&index=0&id=62b73bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b73bbd",
  null
  
)

export default component.exports